import type React from 'react'
import {clsx} from 'clsx'
import styles from './Base.module.css'

export default function Base({
  className,
  style,
  ...rest
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return <div className={clsx(styles.base, className)} style={style} {...rest} />
}
